import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	learnMore: {
		id: 'eoc-heartbeats.tour.learn-more.no-translate',
		defaultMessage: 'Learn More',
		description: 'Action button that redirects user to learn more page',
	},
	ok: {
		id: 'eoc-heartbeats.tour.ok.no-translate',
		defaultMessage: 'OK',
		description: 'Action button that finishes spotlight',
	},
	heading: {
		id: 'eoc-heartbeats.tour.heading.no-translate',
		defaultMessage: 'Easy access to heartbeat actions',
		description: 'Heading of the spotlight',
	},
	description: {
		id: 'eoc-heartbeats.tour.description.no-translate',
		defaultMessage: 'Copy heartbeat’s name, edit, duplicate, and manage more heartbeat actions.',
		description: 'Description of the spotlight',
	},
});

export default messages;
